import { Routes } from '@core/constants/routes';
import { mergeRoutes, MergeRoutesConfig } from '@core/lib/merge-routes';
import {
  NavigateOptions,
  useNavigate as useRouterNavigate,
} from 'react-router-dom';

export const useNavigate = () => {
  const routerNavigate = useRouterNavigate();

  const navigate = (
    routes: Routes | Routes[],
    config?: MergeRoutesConfig & { navigateOptions?: NavigateOptions }
  ) => routerNavigate(mergeRoutes(routes, config), config?.navigateOptions);

  return navigate;
};
